import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/mehmet1700'
      className='link footer__link'
      target="_blank"
      rel="noopener noreferrer"
    >
      Created by Mehmet Karaca
    </a>
    <span style={{margin: '0 0.5em'}}>|</span>
    <a
      href="/impressum"
      className="link footer__link"
    >
      {window.navigator.language.startsWith('de') ? 'Impressum' : 'Imprint'}
    </a>
  </footer>
)

export default Footer
